import React, { useState, useContext, useEffect } from "react";
import {
  Grid2,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Tooltip,
  Fab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { Edit, Save, History, Delete, Add } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { Line } from "react-chartjs-2";
import AuthContext from "../Context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getPatientDetails } from "../API/PatientsApi";
import { useSnackbar } from "../Utility/UserMessageContext";
import dayjs from "dayjs";
import PatientVisits from "./PatientVisits";
import { capitalizeFirstLetter, formatAge } from "../Utility/Utility";
import PatientVitals from "./PatientVitals";
import PatientVisitTimeline from "./PatientVisitTimeline";

function PatientDetails({ patientId, onOpenTab, patient, onViewDocument }) {
  const { auth } = useContext(AuthContext);
  const { showSnackbar } = useSnackbar();
  const [currentPatient, setCurrentPatient] = useState(patient || {});
  const [editFields, setEditFields] = useState({
    patientDetails: false,
    contactInfo: false,
    emergencyContact: false,
    insurance: false,
    vitals: false,
    medicalRecords: false,
    visits: false,
    services: false,
  });
  const [imagePreview, setImagePreview] = useState(
    currentPatient?.photo || null
  );

  useEffect(() => {
    const loadPatient = async () => {
      const result = await getPatientDetails(auth, patientId);
      if (result.isSuccess) {
        setCurrentPatient(result.data);
      } else {
        showSnackbar("Failed to load patient details.", "error");
      }
    };
    loadPatient();
  }, [patientId]);

  // Function to get the latest recorded value for each vital type

  const toggleEdit = (field) => {
    setEditFields((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  // const handleEdit = () => {

  //   onOpenTab("editPatient", currentPatient);
  // };
  const handleEdit = () => {
    if (onOpenTab && typeof onOpenTab === "function") {
      onOpenTab(currentPatient);
    } else {
      console.error("onOpenTab is not a function");
    }
  };
  return (
    <>
      <Grid2
        container
        spacing={2}
        sx={{ padding: 2, maxHeight: "80vh", overflowY: "auto" }}
        size={12}
      >
        

        {/* Patient Details */}
        <Grid2 container size={12} spacing={2}>
          {/* Left Side - Patient Details */}
          <Card variant="outlined" sx={{ width: "100%" }}>
            <CardHeader
              subheader="Patient's Details"
              action={
                <Tooltip title="Edit Patient Details">
                  <IconButton onClick={handleEdit} sx={{ padding: "0px" }}>
                    <Edit />
                  </IconButton>
                </Tooltip>
              }
            ></CardHeader>
            <CardContent>
              <Grid2 container size={12}>
                <Grid2
                  container
                  size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
                >
                  <Grid2 container size={12}>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Name</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {`${capitalizeFirstLetter(
                            currentPatient.firstName
                          )} ${capitalizeFirstLetter(currentPatient.lastName)}`}
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Address</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {currentPatient.addressHouseNo || "Not Provided"}
                          ,&nbsp;
                          {currentPatient.addressStreet || "Not Provided"}
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                      >
                        <Typography>
                          <strong>Next of Kin</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
                      >
                        <Typography>
                          {currentPatient.emergencyContactName ||
                            "Not Provided"}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 container size={12}>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>MRN</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>{currentPatient.mrn}</Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>City, State</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {currentPatient.addressCity || "Not Provided"},&nbsp;
                          {currentPatient.addressState || "Not Provided"},&nbsp;
                          {currentPatient.addressPin}
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                      >
                        <Typography>
                          <strong>Contact No.</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
                      >
                        <Typography>
                          {currentPatient.emergencyContact || "Not Provided"}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 container size={12}>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Age</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {formatAge(currentPatient.ageInYears)}
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Country</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {currentPatient.addressCountry || "Not Provided"}
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                      >
                        <Typography>
                          <strong>Relationship</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
                      >
                        <Typography>
                          {currentPatient.relationship || "Not Provided"}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 container size={12}>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Birth Date</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {dayjs(currentPatient.dateOfBirth).format(
                            "DD-MMM-YYYY"
                          )}
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Phone No.</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>{currentPatient.mobileNo}</Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 container size={12}>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Gender</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>{currentPatient.gender}</Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2
                      container
                      size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }}
                    >
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
                      >
                        <Typography>
                          <strong>Email Id</strong>
                        </Typography>
                      </Grid2>
                      <Grid2
                        container
                        size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
                      >
                        <Typography>
                          {currentPatient.emailId || "Not Provided"}
                        </Typography>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid2>
                <Grid2 container size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
                  <img
                    src={
                      imagePreview // Show uploaded image if available
                        ? imagePreview
                        : currentPatient?.photo // Check if `photo` exists and is not empty
                        ? currentPatient.photo
                        : currentPatient?.gender === "Male"
                        ? "./placeholder-image-male-gender.webp"
                        : "./placeholder-image-female-gender.webp"
                    }
                    alt="PatientPhoto"
                    width="120"
                    height="120"
                    className="border rounded p-0"
                  />
                </Grid2>
              </Grid2>
            </CardContent>
          </Card>
        </Grid2>

        {/* Visits */}
        <PatientVisits
          currentPatient={currentPatient}
          onViewDocument={onViewDocument} // Pass the onOpenTab function
        />
        {/* <PatientVisitTimeline visits={currentPatient.visits} /> */}

        {/* Vitals History */}

       {/* <Grid2 container size={12}>
        <PatientVitals currentPatient={currentPatient} />
       
        </Grid2>  */}

      
      </Grid2>
    </>
  );
}

export default PatientDetails;
